window.FA_QUIZ_FLOWS = window.FA_QUIZ_FLOWS || {};

window.FA_QUIZ_FLOWS['chubby-arms'] = {
  id: 'chubby-arms',
  klaviyoEvent: 'Chubby Arms Quiz Completed',

  scoring: {
    map: {
      s1: [0, 1, 2, 3],
      s2: [1, 0],
      s3: [2, 3, 2, 2, 1],
      s4: [3, 0],
      s5: [3, 3, 2, 0],
      s6: [3, 2, 1, 2],
      s9: [0, 1, 2, 3],
      s10: [3, 2, 0, 0],
      s11: [3, 0, 1],
      s12: [0, 1, 2, 3]
    },
    tiers: [
      { id: 'high', min: 18 },
      { id: 'medium', min: 10 },
      { id: 'low', min: 0 }
    ],
    overrides: [
      { when: { s5: 3, s4: 1 }, force: 'low' },
      { when: { s5: 2, s4: 1 }, fromTier: 'high', toTier: 'medium' },
      { when: { s4: 0, s5: [0, 1] }, fromTier: 'low', toTier: 'medium' }
    ]
  },

  gauge: {
    title: 'Your Arm Tone Score',
    scoreLabel: 'Your score:',
    labels: ['UNDER-TONED', 'LOW', 'NORMAL', 'OPTIMAL']
  },

  chart: {
    yLabels: ['Optimal', 'Normal', 'Low', 'Under-toned'],
    xLabels: ['Now', '30 days', '60 days', '90 days'],
    calloutLabel: 'Your level'
  },

  steps: [
    {
      id: 'question_1',
      type: 'hero',
      title: 'Find out why your arms stay <br>chubby no matter what you try',
      sub: "This 2-minute assessment analyzes your arm shape, habits, and <br>muscle tone to find what's holding your progress back.",
      testimonial: { text: 'Took maybe a minute. My arms finally started toning up after this quiz.', initial: 'S', name: 'SARAH', badge: 'Verified buyer' },
      qLabel: 'How old are you?',
      q: 's1',
      options: ['In my 20s', 'In my 30s', 'In my 40s', 'In my 50s or later']
    },
    {
      id: 'question_2',
      type: 'question',
      title: 'What best describes you?',
      q: 's2',
      options: ['Female', 'Male'],
      helper: 'Arm fat and muscle tone differ by biological sex. We tailor your results accordingly.'
    },
    {
      id: 'question_3',
      type: 'question',
      title: 'What bothers you most about your <br>arms?',
      q: 's3',
      options: ['They look soft and jiggly', "Upper-arm fat won't go away", 'They look big in photos and sleeves', 'Loose skin when I wave', 'No definition no matter what I do']
    },
    {
      id: 'question_4',
      type: 'question',
      title: "Do your arms stay soft even when you lose weight, like the scale drops <br>but your arms don't change?",
      titleWide: true,
      q: 's4',
      options: ['Yes', 'No']
    },
    {
      id: 'question_5',
      type: 'question',
      title: 'How do your arms look <br>compared to a few years ago?',
      q: 's5',
      options: ['Chubbier - sleeves feel tighter', 'Softer - lost firmness and shape', 'About the same, but less toned', 'Slim and defined - no complaints']
    },
    {
      id: 'question_6',
      type: 'question',
      title: 'When did you start noticing <br>changes in your arms?',
      q: 's6',
      options: ['Over a year ago', 'In the past year', 'In the past few months', "They've always been like this"]
    },
    {
      id: 'question_7',
      type: 'question',
      title: "What's your ideal look for your <br>arms?",
      q: 's7',
      options: ['Slimmer, more toned arms', 'Definition - not bulky muscle', 'Confidence in sleeveless tops', 'Firmer skin, less jiggle', 'All of the above']
    },
    {
      id: 'social_proof',
      type: 'interstitial',
      title: 'You are in the right place.',
      sub: 'Over 100,000+ women have firmed and toned their arms with the right supplement support.',
      cta: 'CONTINUE',
      testimonials: [
        { text: 'Eight weeks in and I finally wear tank tops again. My arms look lifted.', initial: 'J', name: 'JESSICA, 34', badge: 'Verified buyer' },
        { text: 'The jiggle is basically gone - my arms feel firm for the first time in years.', initial: 'A', name: 'AMANDA, 28', badge: 'Verified buyer' }
      ]
    },
    {
      id: 'question_8',
      type: 'question',
      title: 'How would you describe your <br>current body composition?',
      q: 's9',
      options: ['Lean and toned', 'Average build', 'Soft with some muscle', 'Out of shape / low muscle tone']
    },
    {
      id: 'question_9',
      type: 'question',
      title: 'How many hours of quality sleep <br>do you get per night?',
      q: 's10',
      options: ['Less than 5 hours', '5-6 hours', '7-8 hours', 'More than 8 hours']
    },
    {
      id: 'question_10',
      type: 'question',
      title: 'Do you struggle to eat enough <br>protein most days?',
      q: 's11',
      options: ['Yes', 'No', 'Not sure'],
      why: 'Without enough protein and creatine, your body can\'t build the lean muscle that makes arms look firm and toned - so even weight loss leaves them soft. This is the #1 reason arms stay "chubby".'
    },
    {
      id: 'analyzing',
      type: 'ring_loader',
      title: 'Analyzing your responses...',
      sub: 'Our algorithm is cross-referencing your answers with body-composition data to find why your arms resist toning.',
      ringLabel: 'analyzes',
      duration: 4000
    },
    {
      id: 'question_11',
      type: 'question',
      title: 'How often do you eat red <br>meat or fish?',
      sub: '(These are the primary natural sources of creatine)',
      q: 's12',
      options: ['Daily - most meals include meat/fish', 'Several times a week', 'Occasionally - mostly plant-based', 'Rarely/never - vegetarian or vegan'],
      why: 'Red meat and fish are the primary dietary sources of creatine - the muscle fuel that gives arms firmness and shape. Low intake means your arm muscles stay under-fueled and soft.'
    },
    {
      id: 'building_profile',
      type: 'step_loader',
      variant: 'counter',
      title: 'Building your profile...',
      sub: 'Personalizing your arm-tone assessment',
      onDone: 'score',
      steps: [
        { num: 1, title: 'Analyzing symptoms', text: 'Cross-checking your reported symptoms' },
        { num: 2, title: 'Cross-referencing lifestyle factors', text: 'Diet, sleep, and activity patterns' },
        { num: 3, title: 'Calibrating supplement protocol', text: 'Matching to clinical benchmarks' },
        { num: 4, title: 'Personalizing your result', text: 'Generating your assessment...' }
      ]
    },
    {
      id: 'results',
      type: 'result_gauge',
      eyebrow: 'YOUR ARM TONE ASSESSMENT',
      title: 'Your Results Are In',
      meansTitle: 'What This Means For You',
      cta: "SHOW ME WHAT'S POSSIBLE"
    },
    {
      id: 'projection',
      type: 'result_chart',
      eyebrow: 'YOUR PROJECTED IMPROVEMENT',
      title: 'Arm Tone Projection',
      sub: 'Based on your unique assessment profile',
      milestonesTitle: 'Expected Milestones',
      cta: 'SEE MY FULL PLAN'
    },
    {
      id: 'final_loader',
      type: 'step_loader',
      variant: 'ring',
      title: 'Finalizing your plan...',
      sub: 'Securing your personalized pricing',
      urgency: 'Your discount expires soon',
      onDone: 'redirect',
      steps: [
        { num: 1, title: 'Protocol calibrated', text: 'Your custom plan is ready' },
        { num: 2, title: 'Supply reserved', text: 'Stock allocated for your order' },
        { num: 3, title: 'Discount applied', text: '47% savings activated' },
        { num: 4, title: 'Generating your link', text: 'Creating secure checkout...' }
      ]
    }
  ],

  tiers: {
    high: {
      cls: 'fq-tier--high',
      levelLabel: 'CRITICALLY LOW',
      pct: '18%',
      activeSegment: 0,
      alertTitle: 'SEVERELY UNDER-TONED',
      alertText: 'Your arms are losing shape faster than fat loss alone can fix. Immediate creatine support strongly recommended.',
      statusValue: 'CRITICAL',
      statusSub: 'UNDER-TONED',
      riskValue: 'HIGH',
      riskSub: 'IMPACT',
      potential: '+60%',
      meansIntro: 'Without support, your arms keep losing the muscle that gives them shape. This directly affects:',
      meansBullets: ['How toned your arms look as you lose weight', 'Firmness and definition through the upper arm', 'Daily energy and stamina', 'Your metabolism and long-term results'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 3,
      lift: '+60%',
      levelColor: '#FF0000',
      calloutBg: '#FFE1E1',
      potentialColor: '#FF0000',
      milestones: [
        { label: 'WEEK 1-2', title: 'Loading Phase', text: 'Daily creatine support starts fueling your arm muscles - the foundation of firm, toned arms.' },
        { label: 'WEEK 3-4', title: 'Activation Phase', text: 'Firmness builds. Arms start feeling tighter as muscle tone returns.' },
        { label: 'MONTH 2-3', title: 'Optimization Phase', text: 'Full saturation reached. Visibly firmer, more defined arms.' }
      ]
    },
    medium: {
      cls: 'fq-tier--medium',
      levelLabel: 'DECLINING',
      pct: '52%',
      activeSegment: 1,
      alertTitle: 'ARM TONE DECLINING',
      alertText: 'Your arms are starting to lose firmness along with fat. Proactive creatine support recommended.',
      statusValue: 'MILD',
      statusSub: 'UNDER-TONED',
      riskValue: 'MODERATE',
      riskSub: 'IMPACT',
      potential: '+30%',
      meansIntro: 'Your arm tone is starting to slip. You may be noticing:',
      meansBullets: ['Reduced energy throughout the day', 'Slower post-workout recovery', 'Softer, less defined arms', 'Gradual loss of muscle tone'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 2,
      lift: '+30%',
      levelColor: '#F19800',
      calloutBg: '#FFF3DF',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1-2', title: 'Loading Phase', text: 'Daily creatine support begins restoring arm muscle fuel. Early firmness improvements.' },
        { label: 'WEEK 3-4', title: 'Stabilization', text: 'Steady improvement in tone, shape, and firmness.' },
        { label: 'MONTH 2-3', title: 'Optimization', text: 'Your arms hold firm, lean muscle. Full benefits realized.' }
      ]
    },
    low: {
      cls: 'fq-tier--low',
      levelLabel: 'NEARLY TONED',
      pct: '74%',
      activeSegment: 2,
      alertTitle: 'TONED - ROOM TO OPTIMIZE',
      alertText: 'Your arms are holding their shape - but not at full potential.',
      statusValue: 'GOOD',
      statusSub: 'UNDER-TONED',
      riskValue: 'LOW',
      riskSub: 'IMPACT',
      potential: '+20%',
      meansIntro: "Your arms are in good shape, but there's still untapped potential:",
      meansBullets: ['Enhanced energy and stamina throughout the day', 'Faster post-workout muscle recovery', 'A more toned, defined look through the arms', 'Better athletic performance and endurance'],
      meansClosing: '<strong>Many people at your level unlock noticeably faster results with creatine. Tap below to see which brand is right for you.</strong>',
      chartStartY: 1,
      lift: '+20%',
      levelColor: '#338411',
      calloutBg: '#E8F8E0',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1-2', title: 'Top-Off Phase', text: 'Daily creatine support tops off your muscle fuel. Subtle firmness and shape gains.' },
        { label: 'WEEK 3-4', title: 'Enhancement', text: 'Consistent improvement in tone, firmness, and definition.' },
        { label: 'MONTH 2-3', title: 'Peak Performance', text: 'Your arms at their best - firm, toned, and defined.' }
      ]
    }
  }
};
